import { createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { queryParamSelector } from '@cbridge-packages/routing';
import { ShowUnmappedParam } from '../_helpers/showUnmappedSearchParam';

export const showUnmappedSelector = createCachedSelector(
  [
    (state) => queryParamSelector(state, ShowUnmappedParam.name),
  ],
  (showUnmapped) => {
    return showUnmapped?.toLowerCase() === 'true';
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
